import { createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATUS } from '../constants';
import { fetchTableSettings } from '../api';

const defaultViewedState = {
  newViewed: [],
  notViewedUuids: [],
  wasSentViewedUuids: [],
};

export const tableSlice = createSlice({
  name: 'table',
  initialState: {
    settings: null,
    status: REQUEST_STATUS.idle,
    error: null,
    canShowShimmer: false,
    viewState: defaultViewedState,
  },
  reducers: {
    updateColumnOrderByTableName: (state, action) => {
      state.settings[action.payload.tableKey].columnOrder = [...action.payload.newOrder];
    },
    updateColumnVisibilityByTableName: (state, action) => {
      state.settings[action.payload.tableKey].columnVisibility = action.payload.newVisibility;
    },
    updateColumnSizingByTableName: (state, action) => {
      state.settings[action.payload.tableKey].columnSizes = action.payload.newColumnSizing;
    },
    updateColumnPinningByTableName: (state, action) => {
      state.settings[action.payload.tableKey].columnPinning = action.payload.newColumnPinning;
    },
    updateShowColumnFilters: (state, action) => {
      state.settings.commonTable.showColumnFilters = action.payload;
    },
    updateDensity: (state, action) => {
      state.settings.commonTable.density = action.payload;
    },
    updateIsFullScreen: (state, action) => {
      state.settings.isFullScreen = action.payload.newIsFullScreen;
    },
    updateCanShowShimmer: (state, action) => {
      state.canShowShimmer = action.payload;
    },
    addViewedState: (state, action) => {
      state.viewState = {
        ...state.viewState,
        ...action.payload,
      };
    },
    addViewedItemState: (state, action) => {
      state.viewState = {
        wasSentViewedUuids: [...new Set([...state.viewState.wasSentViewedUuids, action.payload])],
        newViewed: [...new Set([...state.viewState.newViewed, action.payload])],
      };
    },
    resetViewedRows: (state) => {
      state.viewState = defaultViewedState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTableSettings.pending, (state) => {
        state.status = REQUEST_STATUS.loading;
      })
      .addCase(fetchTableSettings.rejected, (state) => {
        state.status = REQUEST_STATUS.failed;
      })
      .addCase(fetchTableSettings.fulfilled, (state, action) => {
        if (action.payload.ok) {
          state.status = REQUEST_STATUS.succeeded;
          const preferences = action.payload.data.data.preferences;

          state.settings = preferences;
        } else {
          state.status = REQUEST_STATUS.failed;
          state.error = action?.payload?.error?.message;
        }
      });
  },
});

export const {
  updateColumnOrderByTableName,
  updateColumnVisibilityByTableName,
  updateColumnSizingByTableName,
  updateColumnPinningByTableName,
  updateShowColumnFilters,
  updateDensity,
  updateIsFullScreen,
  updateCanShowShimmer,
  addViewedState,
  resetViewedRows,
  addViewedItemState,
} = tableSlice.actions;

export default tableSlice.reducer;
